module.exports = __webpack_public_path__ + "static/media/42x38-5.a8278799.png";